import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Cppsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Cuserfunction(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  


return(
    <div>
         
           <Sides/>
       <Helmet>
 
 <title>User-defined function in C++ tutorial For Beginners</title>
 <meta name="description" content="User-defined function c++ tutorial for beginners.The program can define its own function and a function consist of the following.CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,User-defined function c++ tutorial for beginners,programming language,tutorial for begineers,learn code in free,c++ programming tutorial for beginners,learn code in free online,cpp user define function,user defined function in c++,example of user defined function in c++,user defined function in c++ language,user defined function program in cpp,user defined function in cpp programming,define user defined function in c++,how to define user defined function in c++,user defined function factorial in cpp,c++ define function pointer" />
 <link rel="canonical" href="https://www.codeexampler.com/cpp-user-defined-function" />
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">User-defined function in a C++ 
</h1>
<div className="first">
        <a href="/cpp-function">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/cpp-passing-argument">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
<p className="mt-4 para">The program can define its function, and a function consist of the following.
</p>

<h2 className="mt-4 mh2">There are five types of User-defined functions:
</h2>

<h3 className="mt-4 mh3">1, Function prototype(declaration)<br/>
2, Function definition<br/>
3, Calling function (accessing)<br/>
4, Function argument(parameter)<br/>
5, Return value by the function<br/>
</h3>



<h2 className='headings'>Q-Write a program use user-defined function in c++ function ?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code >{"\n"}
          <span className="qwerty-10">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}
            <span className="qwerty-5">using </span>
            <span className="qwerty-2">namespace </span>
            <span className="qwerty-5">std</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4">void </span>
            <span className="qwerty-5">hello</span>
            <span className="qwerty-3">() </span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"} {"\n"}
            <span className="qwerty-4"> cout </span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-4">Hello</span>
              <span className="qwerty-11"> function\n</span>
              <span className="qwerty-4"> ";</span>
              {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"}
            <span className="qwerty"> int</span>
              <span className="qwerty-6"> main</span>
              <span className="qwerty-3"> ()</span>
              {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}
            <span className="qwerty-4"> cout</span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-10">This is a</span>
            <span className="qwerty-2"> Function </span>
            <span className="qwerty-2">program\n</span>
              <span className="qwerty-3"> ";</span>
            {"\n"}
            <span className="qwerty"> hello </span>
            <span className="qwerty-3">( ); </span>
            <span className="qwerty-5">// Calling function </span>
            {"\n"}
            <span className="qwerty-4"> cout</span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-10">Hello is a</span>
            <span className="qwerty-2"> function </span>
              <span className="qwerty-3">";</span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code >
            {"\n"} 
            <span className="qwerty-11">This is a </span>
              <span className="qwerty">Function </span>
              <span className="qwerty-10">program</span>
              {"\n"}
              <span className="qwerty-11">Hello </span>
              <span className="qwerty">function </span>
              {"\n"}
              <span className="qwerty-11">Hello is a </span>
              <span className="qwerty">Function </span>
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>



<h2 className='headings'>Q-What will be the output of the following function program when a person goes from the USA and stay in the UK and create a plane to travel to India?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code >{"\n"}
          <span className="qwerty-10">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}
            <span className="qwerty-5">using </span>
            <span className="qwerty-2">namespace </span>
            <span className="qwerty-5">std</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-5">void </span>
            <span className="qwerty-4">USA</span>
            <span className="qwerty-3">() </span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"} {"\n"}
            <span className="qwerty-9"> cout </span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-4">USA</span>
              <span className="qwerty-11"> Journey\n</span>
              <span className="qwerty-4">";</span>
              {"\n"}
              <span className="qwerty-3"> &#125; </span>
            {"\n"}
              <span className="qwerty-4"> void </span>
            <span className="qwerty">Uk</span>
            <span className="qwerty-3">() </span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}
            <span className="qwerty-5"> USA</span>
            <span className="qwerty-3">(); </span>
            {"\n"}
            <span className="qwerty-9"> cout </span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-4">UK</span>
              <span className="qwerty-11"> Journey\n</span>
              <span className="qwerty-4">";</span>
              {"\n"}
              <span className="qwerty-3"> &#125; </span>
            {"\n"}
            <span className="qwerty"> int</span>
              <span className="qwerty-6"> main</span>
              <span className="qwerty-3"> ()</span>
              {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}
            <span className="qwerty-9"> cout </span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-10">Travel</span>
            <span className="qwerty-2"> start\n</span>
              <span className="qwerty-3">";</span>
            {"\n"}
            <span className="qwerty"> Uk </span>
            <span className="qwerty-3">( ); </span>
            {"\n"}
            <span className="qwerty-9"> cout </span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-5">India</span>
            <span className="qwerty-2"> Journey</span>
              <span className="qwerty-3">";</span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code >
            {"\n"} 
            <span className="qwerty-10">travel </span>
              <span className="qwerty">start </span>
              {"\n"}
              <span className="qwerty-4">USA </span>
              <span className="qwerty-11">journey </span>
              {"\n"}
              <span className="qwerty">UK </span>
              <span className="qwerty-11">journey </span>
              {"\n"}
              <span className="qwerty-5">India </span>
              <span className="qwerty">journey </span>
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>

<h1 className="mt-5">  </h1>
<div className="back">
        <a href="/cpp-function">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/cpp-passing-argument">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div>
    </div>
)

}
export default Cuserfunction;